module.exports = __webpack_public_path__ + "static/media/blogOne.7afc2c12.jpg";